import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { useTranslation } from "react-i18next";
import { ChoiceColumns } from "./choice-columns";
var headerKeys = {
    size: "edit_grip_position.select_cup_size",
    material: "edit_grip_position.select_cup_material",
    hardness: "edit_grip_position.select_cup_hardness",
    bellows: "edit_grip_position.select_cup_bellows",
};
/* Shown for a cup Tacton has no value for, e.g. the hardness of a silicone
 * cup, so the line through the picks still reaches the cup's image. */
var noValueLabel = "–";
/**
 * Picks a suction cup within its family column by column — size, material,
 * hardness and, for the cups that have them, bellows — each column offering
 * only what the picks to its left come with. Every click picks a cup, so the
 * columns always show the cup the node has.
 */
export var CupChoiceSelect = function (_a) {
    var cupChoice = _a.cupChoice;
    var t = useTranslation().t;
    var columns = cupChoice.columns, selected = cupChoice.selected, selectedCup = cupChoice.selectedCup, onSelect = cupChoice.onSelect;
    var choiceColumns = columns.map(function (_a) {
        var key = _a.key, values = _a.values;
        return ({
            header: t(headerKeys[key]),
            options: values.map(function (value) { return ({
                label: value || noValueLabel,
                isSelected: value === (selected === null || selected === void 0 ? void 0 : selected[key]),
                onSelect: function () { return onSelect(key, value); },
            }); }),
        });
    });
    return (_jsx(ChoiceColumns, { columns: choiceColumns, thumbnail: selectedCup === null || selectedCup === void 0 ? void 0 : selectedCup.image, summary: selected && (selectedCup === null || selectedCup === void 0 ? void 0 : selectedCup.label) }));
};
